/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import RelocationDeliveryView from '../../../order/forms/DeliveryFormView/RelocationDeliveryView/RelocationDeliveryView';

import tmplDeliveryScheduleRelocationCardView from './DeliveryScheduleRelocationCardView.hbs';

const DeliveryScheduleRelocationCardView = View.extend({
  template: tmplDeliveryScheduleRelocationCardView,

  className: 'delivery-schedule-relocation-collection-view',

  regions: {
    deliverySchedule: '.delivery-schedule'
  },

  onRender() {
    const relocationDeliveryView = new RelocationDeliveryView({
      editable: this.options.editable,
      model: this.model
    });
    this.showChildView('deliverySchedule', relocationDeliveryView);
  }
});

export default DeliveryScheduleRelocationCardView;
